/**
 * Label — the small uppercase gold eyebrow above a heading.
 *
 * "YOUR STANDING", "MY PORTFOLIO", "UP NEXT". It is the prestige marker the
 * student design puts over a hero title, and it was a global `.label` class —
 * a name generic enough that a stylesheet in any other area could have
 * collided with it.
 */

import type { HTMLAttributes, ReactNode } from 'react';
import styles from './label.module.css';

interface LabelProps extends HTMLAttributes<HTMLSpanElement> {
  className?: string;
  children?: ReactNode;
}

export function Label({ className, children, ...rest }: LabelProps) {
  return (
    <span className={[styles.label, className].filter(Boolean).join(' ')} {...rest}>
      {children}
    </span>
  );
}
